(function() {
	'use strict';

	angular.module('app.leanProjects')
		.directive('teamSection', teamSection);

	teamSection.$inject = ['$rootScope'];

	function teamSection($rootScope) {
		return {
			restrict: 'EA',
			templateUrl: '/application/f/lean-projects/projects/team-section.html',
			scope: {
				projectNdx: '@projectNdx',
				leanDirFactoryNdx: '@leanDirFactoryNdx',
				managerNdx: '@managerNdx',
				details: '=',
				userRoles: '@userRoles'
			},
			controller: teamSectionController,
			controllerAs: 'teamSectionController',
			bindToController: true
		};
	}

	teamSectionController.$inject = ['$scope', '$rootScope', '$uibModal', '$compile', '$translate',
		'editProjectService', 'leanProjectAuthService', 'newProjectService', 'viewProjectsService'];
	function teamSectionController($scope, $rootScope, $uibModal, $compile, $translate,
			editProjectService, leanProjectAuthService, newProjectService, viewProjectsService) {
		var vm = this;
		this.$onInit = function () {
			init();
		};
		vm.roleList =  [{'role':'Team Member'}, {'role':'Project Manager'}, {'role':'Project Administrator'}, {'role':'Support'}, {'role':'Project Sponsor'}];
		vm.roleList.forEach(function(role) {
			role.roleDisplay = $translate.instant(role.role);
		});
		vm.teamMembersOnlyList = [{'display': $translate.instant('All Users'), 'value': 'allUsers'}, {'display': $translate.instant('Team Only'), 'value': 'teamMembersOnly'}];
		vm.team = [];
		vm.teamList = [];
		vm.actionIsAllowed = actionIsAllowed;
		vm.deleteMember = deleteMember;
		vm.showEditList = showEditList;
		vm.saveEditList = saveEditList;
		vm.cancelEdit = cancelEdit;
		vm.addUser = addUser;
		vm.isLoading = true;

		function actionIsAllowed(action) {
			return leanProjectAuthService.actionIsAllowed(action, vm.details);
		}

		function showEditList(type, rowNdx) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + type + rowNdx);
			var pos = cell.offset();
			var editTemplate = getListTemplate(pos, type, rowNdx);
			if (type == 'role') {
				vm.currentListOption = vm.team[rowNdx].role;
			} else {
				if (vm.details.teamMembersOnly) {
					vm.currentListOption = 'teamMembersOnly';
				} else {
					vm.currentListOption = 'allUsers';
				}
			}
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code === 13) {
					vm.saveEditList(type, rowNdx);
				} else if (code === 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function getListTemplate(position, type, rowNdx) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 340 > windowWidth) {
				position.left = position.left - (position.left + 340 - windowWidth - 8);
			}
			if (position.top + 240 > windowHeight) {
				position.top = position.top - (position.top + 240 - windowHeight - 8);
			}
			var label;
			var display;
			var value;
			var listName;
			if (type == 'role'){
				label = 'Role';
				display = 'role';
				value = 'role';
				listName = 'roleList';
			} else {
				label = 'Viewable By';
				display = 'display';
				value = 'value';
				listName = 'teamMembersOnlyList';
			}

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader"><span translate>Choose ' + label + '</span></div>' +
				'<ui-select append-to-body="true" theme="bootstrap" ng-model="teamSectionController.currentListOption">' +
				'<ui-select-match placeholder="{{\'Select ' + label + '...\'' + ' | translate}}">' +
				'{{$select.selected.' + display + '}}' +
				'</ui-select-match>' +
				'<ui-select-choices repeat="item.' + value + ' as item in teamSectionController.' + listName + ' | filter: $select.search">' +
				'<div>{{item.' + display + '}}</div>' +
				'</ui-select-choices>' +
				'</ui-select>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="teamSectionController.cancelEdit()">{{\'Cancel\' | translate }} </button>' +
				'<button class="button flat colored" ng-click="teamSectionController.saveEditList(\'' + type + '\', ' + rowNdx + ')">{{\'Save\' | translate }}</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function saveEditList(type, rowNdx) {
			var saveObj = {};
			saveObj[type] = vm.currentListOption;
			if (type == 'role') {
				saveObj.userNdx = vm.team[rowNdx].leanDirUserNdx;
				if (saveObj[type] != vm.team[rowNdx][type]) {
					editProjectService.editMember(vm.projectNdx, vm.leanDirFactoryNdx, saveObj,
						(new Date(vm.details.lastModified)).toUTCString())
						.then(function(message) {
							var isSuccessful = message == 'User role saved successfully';
							$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
							if (isSuccessful) {
								if (vm.currentListOption == 'Project Manager') {
									vm.details.projectManager = vm.team[rowNdx].name;
									vm.details.projectManagerId = vm.team[rowNdx].leanDirUserNdx;
								}
								$rootScope.$emit('activityUpdated');
								$scope.$emit('updateLastModified');
								loadTeam();
							}
						});
				}
			} else {
				saveObj.id = vm.projectNdx;
				vm.currentListOption = vm.currentListOption == 'teamMembersOnly' ? true : false;
				saveObj[type] = vm.currentListOption;
				if (vm.details.teamMembersOnly != vm.currentListOption) {
					viewProjectsService.saveProject(saveObj, vm.leanDirFactoryNdx,
						(new Date(vm.details.lastModified)).toUTCString())
						.then(function(response) {
							if (response && response.status && response.status >= 200 && response.status < 400) {
								$rootScope.$emit('toast', {'message': 'Viewable by was saved successfully', 'success': true});
								$rootScope.$emit('activityUpdated');
								vm.details.teamMembersOnly = vm.currentListOption;
								vm.currentListOption = '';
								setTeamMembersDisplay();
								$scope.$emit('updateLastModified');
							} else if (response && response.status === 412) {
								var errorMessage = 'This project has been updated since you last loaded the page, please refresh the page';
								if (response && response.data && response.data.error) {
									errorMessage = response.data.error;
								}
								$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
							} else {
								$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
							}
						});
				}
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		}

		function cancelEdit() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		}

		function deleteMember(rowNdx) {
			var memberNdx = vm.team[rowNdx].memberNdx;
			var confirmScope = $scope.$new();
			confirmScope.additionalText = 'delete this member';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				instance.close();
				confirmScope.$destroy();
				editProjectService.deleteMember(vm.projectNdx, vm.leanDirFactoryNdx, memberNdx,
					(new Date(vm.details.lastModified)).toUTCString()).then(function(message) {
					var result = message ===  'Member deleted successfully';
					$rootScope.$emit('toast', {'message': message, 'success': result});
					$rootScope.$emit('activityUpdated');
					$scope.$emit('updateLastModified');
					if (result) loadTeam();
				});
			};
		}

		function addUser() {
			var addUserScope = $scope.$new();
			addUserScope.roles = vm.roleList;
			editProjectService.getUsersNotInProject(vm.leanDirFactoryNdx, vm.projectNdx).then(function(users) {
				addUserScope.users = users;
			});
			addUserScope.selected = {};
			addUserScope.selected.role = 'Team Member';
			addUserScope.save = save;
			addUserScope.closeDialog = closeDialog;
			addUserScope.roleChange = roleChange;
			addUserScope.showSingleSelect = false;
			addUserScope.filterUsers = filterUsers;
			var opts = {
				scope: addUserScope,
				templateUrl: '/application/f/lean-projects/add-user.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);

			function roleChange() {
				if (addUserScope.selected.role != null) {
					if (addUserScope.selected.role === 'Project Manager') {
						addUserScope.showSingleSelect = true;
					} else {
						addUserScope.showSingleSelect = false;
					}
					addUserScope.selected.user = null;
				}
			}

			function save() {
				var userObj = {};
				userObj.role = addUserScope.selected.role;
				userObj.userNdx = Array.isArray(addUserScope.selected.user) ? addUserScope.selected.user.toString() : addUserScope.selected.user;
				editProjectService.addMember(vm.projectNdx, vm.leanDirFactoryNdx, userObj,
					(new Date(vm.details.lastModified)).toUTCString())
					.then(function(message) {
						var isSuccessful = message == 'User added successfully';
						$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
						if (isSuccessful) {
							if (userObj.role == 'Project Manager') {
								var index = findInArray(addUserScope.users, 'id', userObj.userNdx);
								vm.details.projectManager = addUserScope.users[index].name;
								vm.details.projectManagerId = userObj.userNdx;
							}
							$rootScope.$emit('activityUpdated');
							$scope.$emit('updateLastModified');
							loadTeam();
						}
						closeDialog();
					});

			}

			function closeDialog() {
				instance.close();
				addUserScope.$destroy();
			};

			function filterUsers(searchTerm) {
				return newProjectService.filterUsers(addUserScope.users, searchTerm);
			}
		}

		function loadTeam() {
			editProjectService.getTeam(vm.projectNdx, vm.leanDirFactoryNdx)
				.then(function(team) {
					vm.teamList = team;
					vm.team = [].concat(vm.teamList);
					vm.isLoading = false;
				});
		}

		function setTeamMembersDisplay() {
			if (vm.details.teamMembersOnly == 0) {
				vm.teamMembersDisplay = $translate.instant('All Users');
			} else {
				vm.teamMembersDisplay = $translate.instant('Team Only');
			}
		}

		function init() {
			loadTeam();
			setTeamMembersDisplay();
		}

		var pmListener = $scope.$on('projectManagerChanged', function() {
			loadTeam();
		});

		$scope.$on('$destroy', function() {
			pmListener();
		});
	}

})();
